<template>
    <v-main v-on:drop.prevent class="mx-xl-12 px-xl-12 mx-md-5 px-md-5 mx-sm-2 px-sm-2 my-0 py-0"
               style="height: 100%;">
        <v-layout row class="my-10">
            <v-flex md12 sm12>
                <div class="ml-6">
                    <div class="text-center text__colour-teal text__size-32 text__style-bold layout__margin__bottom-20">Pageflex template</div>

                    <v-layout row class="layout__width-1100px layout__margin-0-auto">

                        <div id="previewImage" class="preview-image"></div>








                    </v-layout>

                    <div class="layout__padding__top-40px">
                        <el-button class="button__base layout__width-200px button-teal layout__cursor-pointer layout__float-left"
                                v-on:click="navigate('data-preview');">Back
                        </el-button>
                    </div>

                    <v-overlay :value="loading">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                </div>
            </v-flex>

        </v-layout>
    </v-main>
</template>

<script>
    import Router from '../../router.js';
    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';

    export default {
        name: 'InstantMarketingTemplate',
        components: {
        },
        mixins: [axios],
        data: () => ({
            loading: false,
        }),
        watch: {
        },
        mounted() {
            parent.postMessage('ScrollIntoView', '*');

            var output = document.getElementById('previewImage');

            var commandPacket = '<?xml version="1.0" encoding="ISO-10646-UCS-2"?>' +
                                '<?pf_command version="1.0"?>' +
                                '<pfjob:job_command xmlns:pfjob="http://www.pageflex.com/schemas" name="SubmitJob">' +
                                '<pfjob:job_variables>' +
                                '<pfjob:var name="ProjectName">M:\\MPower\\eServices Projects\\Generic Property Customers\\RAV02 Ravensworth\\CAMPAIGNS\\2018\\Marketing Materials\\We Have Moved Flyer A6L 2pp\\RAV02 Ravensworth We Have Moved Flyer A6L 2pp.pf</pfjob:var>' +
                                '<pfjob:var name="_sys_FinalOutputDir">m:\\pfout\\pfout</pfjob:var>' +
                                '<pfjob:var name="_sys_ClientJobMonitor">true</pfjob:var>' +
                                '<pfjob:var name="JobName">JPGLARGE</pfjob:var>' +
                                '</pfjob:job_variables>' +
                                '<pfjob:doc_variables>' +
                                '<pfjob:var name="varBranch_Telephone">01670 713333</pfjob:var>' +
                                '<pfjob:var name="PicPage_01_Image_01">\\\\tkcanvas\\guardian\\imagelib_GK\\originals\\RAV02\\136281\\136281_619.jpg</pfjob:var>' +
                                '<pfjob:var name="varUserLogoSQL">\\\\tkcanvas\\guardian\\imagelib_gk\\originals\\RAV02\\136281\\136281_1516.pdf</pfjob:var>' +
                                '<pfjob:var name="varSurnameSQL">Goodliffe</pfjob:var>' +
                                '<pfjob:var name="varJobTitleSQL"></pfjob:var>' +
                                '<pfjob:var name="SECEND_BRANCH_DETAILS"></pfjob:var>' +
                                '<pfjob:var name="varAddressLine5SQL">Northumberland</pfjob:var>' +
                                '<pfjob:var name="varVendors_Telephone"></pfjob:var>' +
                                '<pfjob:var name="varTemplateRefSQL">RAV02 Ravensworth We Have Moved Flyer A6L 2pp</pfjob:var>' +
                                '<pfjob:var name="varAddressLine4SQL">Cramlington</pfjob:var>' +
                                '<pfjob:var name="varBranch">Ravensworth</pfjob:var>' +
                                '<pfjob:var name="PicPage_01_Image_01_flag"></pfjob:var>' +
                                '<pfjob:var name="SECEND_UPLOAD_IMAGES"></pfjob:var>' +
                                '<pfjob:var name="varAddressLine3SQL"></pfjob:var>' +
                                '<pfjob:var name="SECSTART_UPLOAD_IMAGES"></pfjob:var>' +
                                '<pfjob:var name="varReference">Mike Test</pfjob:var>' +
                                '<pfjob:var name="varFirstNameSQL">Nichola</pfjob:var>' +
                                '<pfjob:var name="varAddressLine2SQL">Nelson Road</pfjob:var>' +
                                '<pfjob:var name="SECSTART_BRANCH_DETAILS"></pfjob:var>' +
                                '<pfjob:var name="varPostCodeSQL">NE23 1BB</pfjob:var>' +
                                '<pfjob:var name="varAddressLine1SQL">2 Arcot Court</pfjob:var>' +
                                '<pfjob:var name="varPageSize">JPGLARGE</pfjob:var>' +
                                '<pfjob:var name="varFaxSQL">01670 713331</pfjob:var>' +
                                '<pfjob:var name="varPage_02_Text_We_Have_Moved"></pfjob:var>' +
                                '<pfjob:var name="drpdownPage_1_Background_Options_We_Have_Moved">White Text on Coloured Background</pfjob:var>' +
                                '<pfjob:var name="VarCampaignIDSQL">9657</pfjob:var>' +
                                '<pfjob:var name="varUsername">simon</pfjob:var>' +
                                '<pfjob:var name="varAccountNumberSQL">RAV02</pfjob:var>' +
                                '<pfjob:var name="varUserInfo1">test 1</pfjob:var>' +
                                '<pfjob:var name="varUserInfo2">test 2</pfjob:var>' +
                                '<pfjob:var name="varUserInfo3">test 3</pfjob:var>' +
                                '<pfjob:var name="varUserInfo4">test 4</pfjob:var>' +
                                '<pfjob:var name="varUserInfo5">test 5</pfjob:var>' +
                                '<pfjob:var name="varUserInfo6">17,31,0,21</pfjob:var>' +
                                '<pfjob:var name="varCompanySQL">Ravensworth</pfjob:var>' +
                                '<pfjob:var name="varEmailSQL">nichola.goodliffe@ravensworth.co.uk</pfjob:var>' +
                                '<pfjob:var name="varDirectLineSQL">01670 713333</pfjob:var>' +
                                '<pfjob:var name="varVendors_Address"></pfjob:var>' +
                                '<pfjob:var name="varPage_01_Title_We_Have_Moved"></pfjob:var>' +
                                '<pfjob:var name="SECSTART_INSERT_TEXT"></pfjob:var>' +
                                '<pfjob:var name="varBranchURLSQL">www.ravensworth.co.uk</pfjob:var>' +
                                '<pfjob:var name="varBranch_Email">anthony.bagg@ravensworth.co.uk</pfjob:var>' +
                                '<pfjob:var name="SECEND_INSERT_TEXT"></pfjob:var>' +
                                '<pfjob:var name="varDespatchRef">XXX1</pfjob:var>' +
                                '</pfjob:doc_variables>' +
                                '</pfjob:job_command>'

            Axios.post('http://51.141.83.152/PageflexServer/SubmitCommandPacket.aspx', commandPacket, {
                headers: {
                    "Content-Type": "application/xml",
                },
            })
            .then(response => {
                console.log(JSON.stringify(response));
                console.log(response.data);

                //var res = response.data.split(": ");
                var res = response.data.split("\n"),
                    line,
                    status,
                    transId;

                for (var i = 0; i < res.length; i++) {
                    //console.log(res[i]);

                    line = res[i].split(": ");

                    if (line[0] == 'R0000000') {
                        transId = line[1];
                        console.log('transId=' + transId);
                    }

                    if (line[0] == 'J0000020') {
                        status = line[1];
                        console.log('status=' + status);
                    }


                }

                //if (status == 'Job Status = SUCCESS') {
                if (status.includes('SUCCESS')) {
                    output.innerHTML = '';
                    var img = new Image(),
                        url = 'http://cc.ravensworth.uk/PFout/PFout/' + transId + '/' + transId + '_00001_1.jpg';
                    img.src = url;
                    //img.style.maxHeight = '100px';
                    //img.style.maxWidth = '450px';
                    output.appendChild(img);
                }





            })
            .catch(error => {
                console.log(error);


            });






        },
        methods: {
            navigate(path) {
                Router.push({
                    path: '/' + path,
                });
            },
        }
    };
</script>
